import { path as financialPath } from "../../financial/path";

import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import type { ILoaderData } from "@pages/panelPages/financialManagements/walletBalance/deposit/deposit";
import { useUIStore } from "@/stores/uiStore";

export const depositRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.deposit.route,
      lazy: () =>
        import(
          "@pages/panelPages/financialManagements/walletBalance/deposit/deposit"
        ),
      loader: ({ params, request }): ILoaderData => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.financialManagements.deposit",
          [
            {
              title: "pageTitle.patientWallet",
              url: financialPath.wallet.link(),
            },
          ],
          "index",
        );
        return { id: params.id! };
      },
    },
    permissions: ["patient", "staff", "admin", "local-admin"],
  },
];
